module.exports = __webpack_public_path__ + "37eecccfbabbc748a8519c8102ea6ed6.png";